import React from 'react';
import { Grid } from '@material-ui/core';

import useRecipesPage from './useRecipesPage';

import RecipeLoading from './RecipeLoading';
import RecipeLoaded from './RecipeLoaded';

const RecipesPage = () => {
  const {
    recipe,
    recipeLiked,
    recipeBookmarked,
    isLoading,
    hasFailed,
    loadRecipe,
    hasLoaded,
    exitPage,
    isRecipeOwnedByUser,
    goToEditPage,
    notFound,
    isAuthenticated,
  } = useRecipesPage();

  return (
    <Grid container justify="center">
      <Grid item container xs={12} sm={10} md={8}>
        {!hasLoaded && (
          <RecipeLoading
            isLoading={isLoading}
            hasFailed={hasFailed}
            notFound={notFound}
            exitPage={exitPage}
            loadRecipe={loadRecipe}
          ></RecipeLoading>
        )}

        {hasLoaded && (
          <RecipeLoaded
            recipeModel={recipe}
            recipeLiked={recipeLiked}
            recipeBookmarked={recipeBookmarked}
            exitPage={exitPage}
            isRecipeOwnedByUser={isRecipeOwnedByUser}
            goToEditPage={goToEditPage}
            showBookmarkIcon={isAuthenticated && !isRecipeOwnedByUser}
          ></RecipeLoaded>
        )}
      </Grid>
    </Grid>
  );
};

export default RecipesPage;
